import Grid from '@components/core/layout/Grid';
import { Image } from '@components/core/Image';
import Button from '@components/core/Button';
import { getInternalPath } from '@helpers/internalLink';

export default function ThreeImageTextSection(props) {
  const ctaLink = props.ctaButton?.link.internalLink ? getInternalPath(props.ctaButton?.link?.internalLink) : props.ctaButton?.link?.externalUrl;
  return (
    <Grid>
      <div className={ sq`
        text-heading-md md:text-heading-lg
        col-span-12 md:col-span-10 xl:col-span-8
        col-start-1 md:col-start-2 xl:col-start-3
        text-center
        mb-6 md:mb-8 xl:mb-12
      `
      }>{ props.header }</div>
      {
        props.columns && props.columns.length > 0 &&
        props.columns.map((column, index) => {
          return (
            <div className='mb-6 md:mb-0 col-span-12 md:col-span-4 flex flex-col items-center' key={ column._key }>
              <div className='w-full max-w-[320px] md:max-w-[360px] aspect-[3/2] rounded-2xl overflow-hidden mb-6 relative'>
                {column.image && (
                  <Image
                    sanityImage={ column.image.image }
                    layout='fill'
                    objectFit='cover'
                    className='w-full h-full'
                    sizes='(min-width: 768px) 360px, 320px'
                  />
                )}
              </div>
              <div className='text-center text-heading-xs md:text-heading-sm text-primary mb-2'>{ column.title }</div>
              <div className='text-center text-body-md md:text-body-lg'>{ column.text }</div>
            </div>
          );
        })
      }
      <div className={ sq`
        col-span-12 md:col-span-10 xl:col-span-6
        col-start-1 md:col-start-2 xl:col-start-4
        flex flex-col
      ` }>
        {
          props.ctaTitle &&
          <div className='text-center text-heading-sm md:text-heading-md mt-6 md:mt-8 xl:mt-12 mb-2'>
            { props.ctaTitle }
          </div>
        }
        {
          props.ctaDescription &&
          <div className='text-center text-body-md md:text-body-lg'>{ props.ctaDescription }</div>
        }
        {
          props.ctaButton &&
          <Button href={ ctaLink } className='self-center mt-4 md:mt-6'>{ props.ctaButton.label }</Button>
        }
      </div>
    </Grid>
  );
}
